import React from 'react'
import './Footer.css'
const Footer = () => {
  return (
    <div className="footer">“If you do not like where you are, move. You are not a tree.”</div>
  )
}

export default Footer